const style = {
  name: {
    color: `black`
  },
  userCount: {
    display: `block`,
    textAlign: `center`,
    fontSize: `13px`
  },
  permCount: {
    display: `block`,
    textAlign: `center`,
    fontSize: `13px`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Community/partials/GroupForm/style/ColorBlind/group.js